<template>
  <div class="zhzdyh">
    <div class="calc-templete">
      <h6>填海造地用海收费计算模版</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>城镇建设填海</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>
              <!-- <t-input v-model="formData.projectName" placeholder="请输入工程名称" ></t-input> -->
            </t-form-item>
            <t-form-item label="工程名称" name="projectName">
              <t-input v-model="formData.projectName" placeholder="请输入工程名称"></t-input>
            </t-form-item>
            <t-form-item label="海域等别" name="grade">
              <t-select v-model="formData.grade" placeholder="请选择海域等别">
          <t-option key="1" label="一等" value="1" />
          <t-option key="2" label="二等" value="2"></t-option>
          <t-option key="3W" label="三等" value="3" />
          <t-option key="4" label="四等" value="4" />
          <t-option key="5" label="五等" value="5" />
          <t-option key="6" label="六等" value="6" />
        </t-select>
            
            </t-form-item>
            <t-form-item label="实物工作量" name="money">
              <t-input-number v-model="formData.money" placeholder="请输入实物工作量" suffix="公顷" type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>
            <t-form-item label="一次性征收" name="collect">
              <t-input v-model="formData.collect" placeholder="请输入一次性征收" suffix="次" type="number"></t-input>
            </t-form-item>
            <t-form-item name="coefficient" label="行业调整" class="form-item-left">
              <t-input-number v-model="formData.coefficient" placeholder="请选择调整系数" theme="normal"></t-input-number>


              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible1">系数说明
                <img src="@/assets/icon/Vector.svg" style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>

            <t-form-item label="让利利率" name="discountRate">
              <t-input-number v-model="discountRate" placeholder="" label="-" suffix="%" :min="0" :max="100" theme="normal" />

            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">点击计算（消耗2积分）</t-button>
          </t-col>
          <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            
            <t-form-item label="收费基价" name="subtotal">
              <t-input v-model="formData.subtotal" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            
            <t-form-item label="折前收费" name="beforeFolding">
              <t-input v-model="formData.beforeFolding" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>

            <t-form-item label="折后收费" name="result">
              <t-input v-model="formData.result" placeholder="" disabled suffix="元" @change="resultChange"></t-input>
            </t-form-item>
            <t-form-item label="金额大写" name="resultChinese">
              <t-input v-model="resultChinese" placeholder="" disabled></t-input>
            </t-form-item>

            <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
            :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
          </t-col>
        </t-row>





        <!-- 
        <t-form-item style="margin-left: 140px">
          <t-row>
            <t-col :span=12>
              <t-space size="10px">
                
                

              </t-space>
            </t-col>
            <t-col :span=12 style="margin-top: 10px;">
              <t-button theme="default" variant="base" @click="handleClear" class="help">是否需要详细过程？给点小费求助·</t-button>
            </t-col>
          </t-row>



        </t-form-item> -->
      </t-form>
      
    </div>
    <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
             <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;" >{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
            </div>
          </t-col>
        </t-row>
      </div>
    </div>
    <t-dialog placement="center" :visible="visible1" :footer="false" :onConfirm="close1" :onClose="close1"
      class="dialog1">
      <span slot="header">
        复杂程度调整系数
        <div class="closeButton" @click="close1"></div>
      </span>
      <t-radio-group v-model="value1" @change="onChange1">
          <t-row>
            <t-col :span="12">
              <div style="width: 960px;margin: 0 auto;">
                <t-radio value="离大陆岸线最近距离2千米以上且最小水深大于5米(理论最低潮面)的离岸式填海，按照征收标准的80%征收-0.8" style="float: left;">离大陆岸线最近距离2千米以上且最小水深大于5米(理论最低潮面)的离岸式填海，按照征收标准的80%征收
              </t-radio> <span style="float: right;line-height: 40px;">0.8</span></div>
            </t-col>
            <t-col :span="12">
              <div style="width: 960px;margin: 0 auto;"><t-radio value="填海造地用海占用大陆自然岸线的，占用自然岸线的该宗填海按照征收标准的
120%征收-1.2" style="float: left;">填海造地用海占用大陆自然岸线的，占用自然岸线的该宗填海按照征收标准的
120%征收 </t-radio><span style="float: right;line-height: 40px;"> 1.2</span></div>
            </t-col>
            <t-col :span="12">
              <div style="width: 960px;margin: 0 auto;"><t-radio value="建设人工鱼礁的透水构筑物用海，按照征收标准的80%征收-0.8" style="float: left;">建设人工鱼礁的透水构筑物用海，按照征收标准的80%征收 </t-radio><span style="float: right;line-height: 40px;"> 0.8</span></div>
            </t-col>
            <t-col :span="12">
              <div style="width: 960px;margin: 0 auto;"><t-radio value="地方人民政府管辖海域以外的项目用海执行国家标准,海域等别按照毗邻最近行政区的等别确定。养殖用海标准按照毗邻最近行政区征收标准征收-1.0" style="float: left;">地方人民政府管辖海域以外的项目用海执行国家标准,海域等别按照毗邻最近行政区的等别确定。养殖用海标准按照毗邻最近行政区征收标准征收 </t-radio><span style="float: right;line-height: 40px;"> 1.0</span></div>
            </t-col>

          </t-row>
          
          
          
          
          
        </t-radio-group>
      

    </t-dialog>
    <!-- <help v-bind:visible.sync="helpOpen"></help> -->
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
  </div>
</template>

<script>
import { gethyjzf } from '@/api/data'
import { listFile } from "@/api/file";
import { listRate } from "@/api/rate";
// import Help from '@/components/Help.vue'

export default {
  name: 'czjsthFee',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    // Help
  },
  data() {
    return {
      
      jsgc: null,
      visible: false,
      downFileUrl:null,
      openFileUrl: null,
      downLoading:false,
      validateMessage: {
        projectName: [
    {
      type: 'error',
      message: '项目名称不能为空',
    },
  ],
  money: [
    {
      type: 'error',
      message: '请输入规范数字',
    },
  ]

},
      rules: {
        projectName:[{ required: true },  {  type: 'warning' }],
        money:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
        grade:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
        collect:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
        coefficient:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
      }, 
      helpOpen:false,
      discountRate: null,
      value1: '',
      visible1: false,
      downData:{},//下载时传值
      rateList:[],
      formData: {
        ificationId:this.$route.query.ification,
        projectName: '',
        grade:null,// 海域等别
        money: null,// 实物工作量
        collect:null,// 征收
        coefficient:null,// 调整系数
        subtotal: null,// 基价
        beforeFolding:null,// 折前
        discountRate: 0,
        discountRateMoney: null,
        result: null// 折后
      },
      
      resultChinese: '',
      fileList: [],
      data: [{

      }],
      
      columns: [
      {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '收费等级',
          width: 100,
          colKey: 'grade',
          // children: [
          //   {
          //     colKey: 'startValue',
          //     title: '',
          //     width: 100,
          //   },
          //   {
          //     title: '终止',
          //     colKey: 'finalValue',
          //     width: 100,
          //   }
          // ],
        },
        {
          title: '费用(万元/公顷)',
          colKey: 'rate',
          width: 100,
        }


      ],
      calculateRange:null,//计算范围
      calculationFormula:null // 计算公式

      
    }
  },
  created(){
this.getList()
  },
  methods: {
    getList(){
      listFile({classificationId:this.$route.query.ification}).then(response => {
        // console.log(response)
        this.fileList = response.rows[0];
        
      });
      listRate({ ificationId: this.$route.query.ification}).then(res => {
       
        let i = 1
        res.rows.forEach((item) => {
          
          if (item.finalValue > 99999999){
            item.finalValue = ""
          }
          item.grade = this.convertToChineseNumber(i)+'等'
          item.id = i++
          this.data.push(item)
        })
        this.data = res.rows
      });
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if(res.data.scope){
          if (res.data.scope.indexOf("\\n")!=-1){
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          }else{
            this.calculateRange = res.data.scope
          }
          
        }else{
          this.calculateRange = '暂无数据'
        }
        if(res.data.particulars){
          if (res.data.particulars.indexOf("\\n")!=-1){
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          }else{
            this.calculationFormula = res.data.particulars
          }
        }else{
          this.calculationFormula = '暂无数据'
        }
      })
    },
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
     if (validateResult === true) {
        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    downLoadWord(){
      this.downLoading = true;
      let wordParam = {
        xmmc:this.formData.projectName,
        xsz:`海域等别:${this.convertToChineseNumber(this.formData.grade)}级;实物工作量:${this.formData.money}公顷;一次性征收:${this.formData.collect}次;行业调整:${this.formData.coefficient};让利利率:${this.discountRate}%。`,
        yjwj:this.fileList ? this.fileList.fileName.split('.')[0] : '--',
        jsgc:this.jsgc,
        fulx:'填海造地用海收费',
        zhj:this.formData.result,

        hydb:this.convertToChineseNumber(this.formData.grade) + '级',
        yhdl:'填海造地用海',
        yhfs:'城镇建设填海',
        fjxs:this.formData.coefficient

      }
      this.download('/project/hyjzf/word', { id: this.downData.id, classId: 97,...wordParam }
        , `填海造地用海收费计算模版.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    handleClear() {
      this.helpOpen = true
    },
    submit() {
      // console.log(111)
      this.formData.discountRate = Number(this.discountRate) / 100
      gethyjzf(this.formData).then(res => {
        this.downData = res.data
         this.formData.money = res.data.money.toString()
        // this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
        this.formData.result = res.data.result.toFixed(2).toString()
        this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
        // this.formData.money.toString()
        this.formData.beforeFolding = res.data.beforeFolding.toFixed(2).toString()
        this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
        this.jsgc = res.data.jsgc
      })
    },
    resultChange(value) {
      this.resultChinese = this.changeNumMoneyToChinese(value)
    },
    openVisible1() {
      this.visible1 = true
    },
    close1() {
      this.visible1 = false;
    },
    onChange1(checkedValues) {
      // console.log('checkedValues:', this.value1, checkedValues.split('-').slice(-1));
      this.formData.coefficient = checkedValues.split('-').slice(-1).toString()
    },
    convertToChineseNumber(number) {
  var chineseNumbers = {
    '0': '零',
  '1': '一',
  '2': '二',
  '3': '三',
  '4': '四',
  '5': '五',
  '6': '六',
  '7': '七',
  '8': '八',
  '9': '九',
    // 添加其他数字的对应关系
  };

  if (number in chineseNumbers) {
    return chineseNumbers[number];
  } else {
    return number; // 如果数字不在范围内，则返回原始数字
  }
}
  },
}
</script>

<style lang="less" >
.zhzdyh {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;


  

  

  

  .dialog1 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 1000px;
      // height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;


      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        background: url('@/assets/dialog-background.png');

        padding: 0;

        .t-form__label {
          height: 32px;
          line-height: 32px;
          font-family: "Regular";
        }

        .custom-cascader-1 {
          width: 300px;
        }

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 40px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;
          line-height: 40px;

          span {
            color: #000000;
          }
        }

        .complexity-table {
          padding: 20px;
          background: url('@/assets/dialog-background.png');
        }
      }
    }
  }
}
</style>
